import { subscribeWithSelector } from "zustand/middleware";
import { shallow } from "zustand/shallow";
import { createWithEqualityFn } from "zustand/traditional";
import type { StateCreator } from "zustand/vanilla";

import { type GlobalGeneralAction, generalActionSlice } from "./actions/general";
import { type GlobalState, initialState } from "./initial-state";

export type GlobalStore = GlobalState & GlobalGeneralAction;

const createStore: StateCreator<
  GlobalStore,
  [["zustand/subscribeWithSelector", never]],
  [],
  GlobalStore
> = (...parameters) => ({
  ...initialState,
  ...generalActionSlice(...parameters),
});

export const useGlobalStore = createWithEqualityFn<GlobalStore>()(
  subscribeWithSelector(createStore),
  shallow,
);

export const getGlobalStoreState = () => useGlobalStore.getState();
